import { render } from "./ConfigDemoWrap.vue?vue&type=template&id=0891b36a"
import script from "./ConfigDemoWrap.vue?vue&type=script&lang=js"
export * from "./ConfigDemoWrap.vue?vue&type=script&lang=js"

import "./ConfigDemoWrap.vue?vue&type=style&index=0&id=0891b36a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__